<template>
  <div class="filtersWrap">
    <div class="row">
      <div class="col-lg-5">
        <div class="form-group">
          <label>{{ "Program.stage" | staticTranslation }}</label>
          <select class="form-control" :value="selectedStageId" @change="onStageChange">
            <option :value="null">{{ "Program.all" | staticTranslation }}</option>
            <option v-for="s in stages" :key="s.id" :value="s.id">
              {{ s.name | translation }}
            </option>
          </select>
        </div>
      </div>

      <div class="col-lg-5">
        <div class="form-group">
          <label>{{ "Program.genre" | staticTranslation }}</label>
          <select class="form-control" :value="selectedGenreId" @change="onGenreChange">
            <option :value="null">{{ "Program.all" | staticTranslation }}</option>
            <option v-for="g in genres" :key="g.id" :value="g.id">
              {{ g.name | translation }}
            </option>
          </select>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "ProgramFilters",
  props: {
    stages: { type: Array, required: true },
    genres: { type: Array, required: true },
    selectedStageId: { required: false, default: null },
    selectedGenreId: { required: false, default: null }
  },
  methods: {
    // Vue2 .sync = emit update:propName
    onStageChange(e) {
      const v = e.target.value === "null" || e.target.value === "" ? null : Number(e.target.value);
      this.$emit("update:selectedStageId", isNaN(v) ? null : v);
    },
    onGenreChange(e) {
      const v = e.target.value === "null" || e.target.value === "" ? null : Number(e.target.value);
      this.$emit("update:selectedGenreId", isNaN(v) ? null : v);
    }
  }
};
</script>

<style scoped>
.filtersWrap {
  padding-bottom: 2.2rem;
}

label {
  color: black;
  font-family: "Transcript Pro";
}

.form-control {
  background-color: black;
  color: #FFCE6D;
  font-family: "Transcript Pro";
  border-color: black;
  border-radius: 0;
}
</style>
